<template>
  <v-card fill-height>
    <v-layout v-if="isPeergroup && !groupBiggerThan100">
      <StrukturBilanzTable :hideHeader="true" :heightSub="tableHeightSub" ref="myTable" tableName="stammdata"
                           edoClassName="sb"></StrukturBilanzTable>
    </v-layout>
    <v-layout v-if="isPeergroup && groupBiggerThan100">
      <v-flex xs12 class="text-xs-left pa-3">
        <span class="title bluetext font-weight-light">{{ 'TEXT_STAMMDATA_NOT_SHOWN' | translate}}</span>
      </v-flex>

    </v-layout>
    <v-layout wrap justify-start v-if="!isPeergroup">
      <v-flex xs12 sm8 md6 v-if="groups != null" v-for="(group,i) in groups" :key="i">
        <v-layout wrap class="pa-4">
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12 class="text-xs-left my-3">
                <span class="title bluetext font-weight-light">{{group.title}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-for="(row,i) in group.items" :key="i">
            <v-layout row>
              <v-flex xs3 class="text-xs-right pr-2">
                <span v-if="row.cells[0]" class="fontsize11 grey--text pt-1 trennung">{{row.cells[0].co}}</span>
              </v-flex>
              <v-flex xs8 sm8 md7 class="spacesmaller bordernone onlytextfield">
                <v-text-field v-if="row.cells[1]" readonly solo :class="getFieldClass(row.cells[1])" background-color="#f4f5f5" flat
                              required
                              @click="clickField(row.cells[1])"
                              v-model="row.cells[1].co"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="!isPeergroup" id="mapDive" style="padding: 20px; height: 300px;">
      <v-flex xs12>
        <l-map ref="myMap" :style="getMapStyle()" :zoom="mapData.zoom" :center="mapData.center"
               v-if="showMap">
          <l-tile-layer :url="mapData.url" :attribution="mapData.attribution"></l-tile-layer>
          <LMarker :lat-lng="mapData.marker" style="width:200px;"></LMarker>
        </l-map>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="!isPeergroup" style="height:140px;">
    </v-layout>
  </v-card>
</template>

<script>
import Vue from 'vue'
import StrukturBilanzTable from './StrukturBilanzTable'
import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
import {latLng} from 'leaflet'
import {LMap, LTileLayer, LMarker, LPopup, LTooltip} from 'vue2-leaflet'

export default {
  name: 'TabStammDaten',
  components: {StrukturBilanzTable, BtnDownloadExcel, LMap, LTileLayer, LMarker, LPopup, LTooltip},
  props: ['data', 'isPeergroup', 'balanceArray', 'balance'],
  methods: {
    open: function () {
      this.reload()
    },
    getLatLngFromAddress: function () {
      Vue.prototype.$api.debug('getLatLngFromAddress', this.stammData)
      var addressData = this.stammData.address
      Vue.prototype.$api.getLatLngFromAddress(addressData, this.onGetAddress)
    },
    onGetAddress: function (address) {
      Vue.prototype.$api.debug('onGetAddress', address)
      // var cmp = this
      if (address.length > 0) {
        this.showMap = true
        this.addressData.lng = address[0].lon
        this.addressData.lat = address[0].lat
        this.mapData.center = latLng(address[0].lat, address[0].lon)
        this.mapData.marker = latLng(address[0].lat, address[0].lon)
        this.$nextTick(() => {
          // cmp.$refs.myMap.update()
        })
      }
    },
    getFieldClass: function (field) {
      if (field && field.co) {
        if (field.co.startsWith('http')) {
          return 'heightLogin handpointer'

        }
        if (field.co.startsWith('https')) {
          return 'heightLogin handpointer'
        }
        if (field.co.startsWith('www.')) {
          return 'heightLogin handpointer'
        }
      }
      return 'heightLogin'
    },
    clickField: function (field) {
      if (field && field.co) {
        if (field.co.startsWith('http')) {
          window.open(field.co, '_blank')
        }
        if (field.co.startsWith('https')) {
          window.open(field.co, '_blank')
        }
        if (field.co.startsWith('www.')) {
          window.open(field.co, '_blank')
        }
      }
    },
    getMapStyle: function () {

      var w = $('#mapDive').width()
      var h = 320
      var style = 'width:' + w + 'px;height:' + h + 'px;z-index: 2;'
      return style
    },
    close: function () {
      if (this.$refs['myTable']) {
        this.$refs['myTable'].close()
      }
    },
    getValueOfStammdata: function (name, defValue) {
      for (var rowIndex in this.myData.table.rows) {
        var row = this.myData.table.rows[rowIndex]
        var cell = row.cells[0].co
        if ((cell === name) && (row.cells.length > 1) && (row.cells[1])) {
          return row.cells[1].co
        }
      }
      return defValue
    },
    onGetData: function (data) {
      Vue.prototype.$api.debug('data', data)
      this.hasWA = data.balanceAvailable || this.isPeergroup // data.maxBalanceYear && (data.maxBalanceYear * 1 > (new Date().getFullYear() - 3))

      if (this.hasWA && this.balance) {
        if (this.balance.aaNr === '0') {
          this.hasWA = false
        }
      }

      Vue.prototype.$eventHub.$emit('hasWA', this.hasWA)

      this.myData = data
      this.stammData.address = this.getValueOfStammdata('Adresse')
      if (!this.stammData.address) {
        this.stammData.address = this.getValueOfStammdata('Address')
      }

      this.stammData.country = this.getValueOfStammdata('Land')
      this.stammData.region = this.getValueOfStammdata('Region')
      this.stammData.crefo = this.getValueOfStammdata('CrefoNr')
      this.stammData.tax = this.getValueOfStammdata('Steuernummer')
      this.stammData.salestax = this.getValueOfStammdata('Ust-ID Nr.')
      this.stammData.lei = this.getValueOfStammdata('LEI')
      this.stammData.bic = this.getValueOfStammdata('BIC')
      this.stammData.legalform = this.getValueOfStammdata('Rechtsform')
      this.stammData.wz = this.getValueOfStammdata('WZ-Code')
      this.stammData.tradename = this.getValueOfStammdata('Branchenbezeichnung')
      this.stammData.foundingyear = this.getValueOfStammdata('Gründungsjahr')
      this.stammData.mother = this.getValueOfStammdata('Ultimative Mutter')
      this.stammData.mothercrefo = this.getValueOfStammdata('CrefoNr ultimative Mutter')
      this.stammData.mothername = this.getValueOfStammdata('Name ultimative Mutter')
      this.stammData.phone = this.getValueOfStammdata('Telefon')
      this.stammData.fax = this.getValueOfStammdata('FAX')
      this.stammData.mail = this.getValueOfStammdata('E-Mail')
      this.stammData.web = this.getValueOfStammdata('Internet')


      var group = null
      for (var rowIndex in this.myData.table.rows) {
        var row = this.myData.table.rows[rowIndex]
        var type = row.type
        if (type === 'hdr') {
          group = {
            title: row.cells[0].co,
            items: []
          }
          this.groups.push(group)
          continue
        }
        if (group != null) {
          group.items.push(row)
        }
      }

      Vue.prototype.$api.hideIdle()
      if (this.$refs['myTable']) {
        this.$refs['myTable'].open(data)
      }
      let cmp = this
      this.$nextTick(function () {
        cmp.getLatLngFromAddress()
      })
    },
    reload: function (configName) {
      Vue.prototype.$api.debug('reload', this.balance)
      if (this.balance === null) return
      Vue.prototype.$api.showIdle()
      this.groups = []
      if (this.isPeergroup) {
        this.groupBiggerThan100 = this.balanceArray.length > 100
        // console.log('groupBiggerThan100', this.groupBiggerThan100, this.balanceArray.length)
        if (!this.groupBiggerThan100) {
          Vue.prototype.$api.getStammDataWithBalanceArray(this.balanceArray, false, this.onGetData)
        } else {
          Vue.prototype.$api.getStammDataWithBalanceArrayLimit1(this.balanceArray, false, this.onGetData)
        }
      } else {
        Vue.prototype.$api.getStammDataWithBalance(this.balance, false, this.onGetData)
      }

    }
  },
  data () {
    return {
      groups: [],
      showMap: false,
      groupBiggerThan100: true,
      myData: null,
      hasWA: false,
      showTextFields: false,
      mapData: {
        zoom: 16,
        center: latLng(51.2179837, 7.2861579),
        url: 'https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: latLng(51.2179837, 7.2861579),
        withPopup: latLng(51.2179837, 7.2861579),
        withTooltip: latLng(51.2179837, 7.2861579),
        currentZoom: 12.5,
        currentCenter: latLng(51.2179837, 7.2861579),
        showParagraph: false,
        mapOptions: {},
        showMap: true
      },
      addressData: {
        town: 'Neuss',
        street: 'Hellersbergstraße 11',
        zipCode: '41460',
        description: '',
        lat: '0',
        lng: '0'
      },
      first: true,
      stammData: {
        name: 'Name',
        address: 'Hellersbergstraße 11,41460 Neuss',
        country: 'Land',
        region: 'Region',
        crefo: 'CrefoNr',
        tax: 'Steuernummer',
        salestax: 'Ust-ID Nr.',
        lei: 'LEI',
        bic: 'BIC',
        legalform: 'Rechtsform',
        wz: 'WZ-Code',
        tradename: 'Branchenbezeichnung',
        foundingyear: 'Gründungsjahr',
        mother: 'Ultimative Mutter',
        mothercrefo: 'CrefoNr ultimative Mutter',
        mothername: 'Name ultimative Mutter',
        phone: 'Telefon',
        fax: 'Fax',
        mail: 'E-Mail',
        web: 'Internet'
      },
      configExcel: {
        excelSheetStammdaten: 1,
        excelSheetStrukturbilanz: 0,
        excelSheetRohbilanz: 0,
        excelSheetKennzahlen: 0,
        excelSheetBilanzrating: 0,
        excelSheetKDF: 0,
        btnName: Vue.i18n.translate('DOWNLOAD_NAME_SD'),
        configName: '',
        type: 'EXCEL-STRUCT'
      },
      tableHeightSub: 100
    }
  },
  mounted () {
    this.groups = []
    // this.open()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabStammDaten.vue